// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__hTzgn","hasError":"TextArea_hasError___VvJ8"};